<template>
  <div class="contact-form">
    <Title title="contact us" sub-title="聯絡我們" />
    <el-form ref="form" :model="form" :rules="rules">
      <el-row>
        <el-col :md="11" :sm="24" :xs="24">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="userName">
                <el-input v-model="form.userName" placeholder="姓名" />
              </el-form-item>
              <el-form-item prop="mobile">
                <el-input v-model="form.mobile" placeholder="電話" />
              </el-form-item>
              <el-form-item prop="email">
                <el-input v-model="form.email" placeholder="Email" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :md="{span: 11, offset: 2}" :sm="24" :xs="24">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="remark">
                <el-input
                  v-model="form.remark"
                  type="textarea"
                  :rows="6"
                  placeholder="内容"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :md="{span: 11, offset: 13}" :sm="24" :xs="24">
          <el-row>
            <el-col class="button-group">
              <el-button native-type="submit" @click="handleSubmit"> 確定送出 </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import Title from './Title.vue'
import api from '@/api'

export default {
  components: {
    Title
  },
  data() {
    return {
      form: {
        userName: '',
        mobile: '',
        email: '',
        remark: ''
      },
      rules: {
        userName: [
          { required: true, message: '姓名為必填', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '手機為必填', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '信箱為必填', trigger: 'blur' },
          { validator: this.validateEmail }
        ],
        remark: [
          { required: true, message: '內容為必填', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.handleContact(this.form)
        }
      })
    },
    validateEmail(rules, value, callback) {
      const regex = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
      if (value.search(regex) === -1) {
        return callback('請輸入正確的 Email 格式')
      }

      return callback()
    },
    async handleContact(data) {
      try {
        const { success } = await api.contact.contactUs(data)
        if (success) {
          this.$message({
            type: 'success',
            message: '資料已送出',
            duration: 1500
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
<style scoped lang="scss">

img {
  height: 40px;
}

.button-group {
  text-align: center;
  @include minWidth992 {
    text-align: right;
  }
}
.el-button {
  background-color: #264682;
  color: #fff;
  border: 0;
  width: 100%;
  max-width:120px;

  &:hover {
    background-color:  #6AF3EA;
  }
}
</style>
